import { fx } from './motion-control.js';

const ATTR_SCOPE = 'data-anim-scope';
const ATTR_TARGET = 'data-anim';
const ATTR_SPLIT = 'data-split';
const ATTR_CHILDREN = 'data-anim-children';

const DEFAULT_EFFECT = {
    stagger: 0.1,
    easing: 'back.out(1.7)',
    duration: 1.2,
    markers: false,
    effect: 'fade-up',
};

const collectTargets = (scope, selector) => {
    if (!scope) return [];
    if (scope.matches(selector)) {
        return [scope];
    }
    return Array.from(scope.querySelectorAll(selector));
};

const setupReveal = (scope, options = {}) => {
    if (!scope) return null;
    const config = { ...DEFAULT_EFFECT, ...options };
    const targets = collectTargets(scope, config.selector || `[${ATTR_TARGET}]`);

    // Contenu contribué ou scope marqué : on anime directement les enfants
    if (scope.classList.contains('tinymce') || scope.hasAttribute(ATTR_CHILDREN)) {
        targets.splice(0, targets.length, ...Array.from(scope.children));
    }
    if (!targets.length) return null;

    const initialValues = { opacity: 0 };
    const effect = scope.getAttribute('data-anim-effect') || config.effect;
    if (effect === 'scale-up') {
        initialValues.scale = 0.5;
    } else {
        initialValues.y = 100;
    }

    fx.set(targets, initialValues);

    let stagger = scope.dataset.animStagger;
    let start = scope.getAttribute('data-anim-start') || 'top bottom';
    let end = scope.getAttribute('data-anim-end') || 'bottom 20%';

    if (stagger) {
        if (stagger.startsWith('{')) {
            stagger = JSON.parse(stagger);
        } else if (!isNaN(stagger)) {
            stagger = parseFloat(stagger);
        }
    }

    config.stagger = stagger || config.stagger;

    const tween = fx.to(targets, {
        y: 0,
        x: 0,
        scale: 1,
        opacity: 1,
        stagger: config.stagger,
        ease: config.easing,
        duration: config.duration,
        scrollTrigger: {
            trigger: scope,
            start,
            end,
            markers: config.markers,
            once: true,
        },
        onComplete: () => fx.set(targets, { clearProps: 'all', attr: { 'data-anim': 'on' } }),
    });

    return tween;
};

const collectScopes = () => Array.from(document.querySelectorAll(`[${ATTR_SCOPE}]`));

export { ATTR_SCOPE, ATTR_SPLIT, ATTR_TARGET };
export { collectScopes, collectTargets, setupReveal };
export default setupReveal;
